import rootReducer from "./root-reducer"

import {configureStore} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";

// https://www.npmjs.com/package/redux-logger
import logger from "redux-logger";
import {X_MODE} from "../config/general-config";

const middlewares = []

// only apply LogRocket's redux-logger in development mode
// eventually, move all in `.env`, but for now in React using general-config.ts
if (process.env.NODE_ENV === "development" && X_MODE === "development") {
    middlewares.push(logger)
}

/**
 * NEW using Redux Toolkit (easier)
 *
 * todo `configureStore()` automatically includes redux-thunk, so no need `middlewares`
 *
 * @sources
 *  - https://github.com/zsajjad/rtk-demo/blob/master/app/configureStore.js
 *  - https://blog.logrocket.com/smarter-redux-with-redux-toolkit/
 *  - https://redux-toolkit.js.org/usage/usage-guide
 */
export const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares,
    preloadedState: {},
    devTools: process.env.NODE_ENV !== "production",
    // devTools: X_MODE !== "production",
    // enhancers: []
})

// https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
// todo not entirely sure it's needed here (we could just use useDispatch())
export type XDispatch = typeof store.dispatch
export const useXDispatch = () => useDispatch<XDispatch>()
